import React from 'react';
import {
  Create,
  useRedirect,
} from 'react-admin';
import { FuneralBaseEdit } from './FuneralBaseEdit';
import { syncFuneralClientsAfterSave } from './FuneralClientsInput';

let pendingFuneralClients: any[] | null = null;

const transformFuneralData = (data: any) => {
  pendingFuneralClients = data._funeral_clients || null;

  const { _funeral_clients, ...rest } = data;
  const cleaned = Object.fromEntries(
    Object.entries(rest).filter(([key]) => !key.startsWith('_fc_client_')),
  );
  return cleaned;
};

export const FuneralCreate = () => {
  const redirect = useRedirect();

  return (
    <Create
      redirect="show"
      transform={transformFuneralData}
      mutationOptions={{
        onSuccess: async (data: any) => {
          if (pendingFuneralClients) {
            await syncFuneralClientsAfterSave(data.id, pendingFuneralClients);
            pendingFuneralClients = null;
          }
          redirect('show', 'funerals', data.id);
        },
      }}
    >
      <FuneralBaseEdit />
    </Create>
  );
};
